import request from '@/utils/request'

// 第一步口令校验
export function verifyStepOne (data) {
  return request.post('/user/step1', data)
}

// 第二步口令校验
export function verifyStepTwo (data) {
  return request.post('/user/step2', data)
}

// 获取首页 统计数据
export function dataRecord () {
  return request.get('/user/dataRecord')
}
